import { TanStackDevtools } from '@tanstack/react-devtools'
import { createRootRoute, HeadContent, Scripts } from '@tanstack/react-router'
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools'
import { PostHogProvider } from 'posthog-js/react'

import { ErrorFallback } from '@/components/error-fallback'
import { SentryTestButton } from '@/components/sentry-test-button'

import { getPostHogApiKey, posthogOptions } from '@/lib/posthog.client'
import { initSentry, Sentry } from '@/lib/sentry.client'

import appCss from '../styles.css?url'

// Initialize Sentry on the client side
// PostHog is initialized by PostHogProvider
initSentry()

export const Route = createRootRoute({
  head: () => ({
    meta: [
      {
        charSet: 'utf-8',
      },
      {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1',
      },
      {
        title: 'Resume Alpha',
      },
    ],
    links: [
      {
        rel: 'stylesheet',
        href: appCss,
      },
      { rel: 'icon', type: 'image/svg+xml', href: '/icon.svg' },
    ],
  }),

  shellComponent: RootDocument,
})

function RootDocument({ children }: { children: React.ReactNode }) {
  const posthogApiKey = getPostHogApiKey()

  return (
    <html lang="en">
      <head>
        <HeadContent />
      </head>
      <body>
        <PostHogProvider apiKey={posthogApiKey || ''} options={posthogOptions}>
          <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
            {children}
          </Sentry.ErrorBoundary>
        </PostHogProvider>
        <SentryTestButton />
        <TanStackDevtools
          config={{
            position: 'bottom-right',
          }}
          plugins={[
            {
              name: 'Tanstack Router',
              render: <TanStackRouterDevtoolsPanel />,
            },
          ]}
        />
        <Scripts />
      </body>
    </html>
  )
}
